import { Close, Search } from "@mui/icons-material";
import { IconButton, Paper, useTheme } from "@mui/material";
import React, { memo, useState } from "react";
import styled from "styled-components";

const Styled = styled.input`
  background-color: transparent;
  height: 100%;
  outline: none;
  margin-left: 10px;
  flex: 1;
  font-size: 0.975rem;
  color: ${(p) => p.color};
  ::placeholder {
    text-shadow: ${(p) => p.tx};
    color: ${(p) => p.color};
    opacity: 0.8;
  }
`;

const StyledInput = memo(
  React.forwardRef((props, ref) => {
    return <Styled ref={ref} {...props} />;
  })
);

function SearchInput({
  value,
  onChange = () => {},
  placeholder = "Pesquisar usuários",
  sx,
  autoFocus = true,
}) {
  const [focused, setFocused] = useState(false);

  const { palette } = useTheme();

  return (
    <Paper
      component="form"
      elevation={focused ? 4 : 0}
      sx={{
        bgcolor: (t) =>
          t.palette.mode === "dark"
            ? !focused
              ? "#323338"
              : "#323338"
            : !focused
            ? "#F0F4FA"
            : "white",
        borderColor: (t) =>
          t.palette.mode === "dark" ? `rgba(255,255,255,.2)` : "rgba(0,0,0,.2)",
        position: "relative",
        transition: "none",
        borderRadius: 2,
        border: 0,
        px: 1,
        height: 47,
        display: "flex",
        alignItems: "center",
        flex: 1,
        width: "100%",
        ...sx,
      }}
    >
      <IconButton>
        <Search />
      </IconButton>
      <StyledInput
        autoFocus={autoFocus}
        placeholder={placeholder}
        tx={`.2pt .2pt 0 ${palette.grey[500]}`}
        color={palette.text.primary}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => onChange(e.target.value)}
        value={value}
      />
      {value && value.length && (
        <IconButton onClick={() => onChange("")}>
          <Close />
        </IconButton>
      )}
    </Paper>
  );
}

export default SearchInput;
